
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { month: '1M', inflows: 850, outflows: 780, net: 70 },
  { month: '2M', inflows: 760, outflows: 820, net: -60 },
  { month: '3M', inflows: 920, outflows: 840, net: 80 },
  { month: '6M', inflows: 1150, outflows: 980, net: 170 },
  { month: '9M', inflows: 980, outflows: 1050, net: -70 },
  { month: '12M', inflows: 1250, outflows: 1180, net: 70 },
];

const CashflowChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip 
          formatter={(value) => [`₹${value} Cr`, undefined]}
          labelFormatter={(label) => `Time Horizon: ${label}`}
        />
        <Legend />
        <Bar dataKey="inflows" name="Cash Inflows" fill="#22c55e" />
        <Bar dataKey="outflows" name="Cash Outflows" fill="#ef4444" />
        <Bar dataKey="net" name="Net Position" fill="#3b82f6" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default CashflowChart;
